import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import { TablePaginationActionsWrapped } from '../../../Helper/Pagination/pagination';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { fetchActivityAction } from '../../../Actions/overviewActions';
import Loader from '../../../Helper/loader/loader';
import './activity.css';
import moment from 'moment';

const styles=theme=>({
    progress: {
        margin: theme.spacing.unit * 2,
    },
    listItem: {
        padding: '10px',
        fontSize:'0.8em',
        borderBottom: '1px solid #ddd',
    },
    subheading: {
        fontSize: '1.2em',
        fontWeight:600
    },
    table: {
        minWidth: 200,
    },
    tableRow: {
        height:45,
        backgroundColor:'white !important',
        fontSize:'15px'
    },
    tableCell:{
        paddingRight:4,
        paddingLeft:5,
        '&:last-child': {
            paddingRight:4,
            paddingLeft:2
        },
    },
    eventListItemText: {
        fontWeight:500,
        padding:0
    },
    eventListItem: {
        paddingTop:2,
        paddingBottom:2
    },
    eventText:{
        fontSize:12,
        fontWeight:600
    },
    page:{
        fontSize:'14px',
        maxWidth:'100px'
    },
});

class ActivityTable extends React.Component {

    constructor(props){
        super(props);
        this.state={
            page:0,
            rowsPerPage:10,
            userName:''
        }
    }

    componentDidMount(){
        this.props.fetchActivityAction(this.props.user.BusinessUser.PlaceID);

        this.interval= setInterval(()=>{
                this.props.fetchActivityAction(this.props.user.BusinessUser.PlaceID);
            }, 50000
        );
    }

    componentWillUnmount(){
        clearInterval(this.interval);
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    render(){
        const { classes,activity,size=activity.results.BusinessActivity.length } = this.props;
        const { rowsPerPage, page } = this.state;
        return(
            <div>
                <div style={{minHeight:'38vh'}}>
                    <Table className={classes.table}>
                        <TableBody>
                            {activity.results.BusinessActivity.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((activity, index) => {
                                if (index < size)
                                    return (
                                        <TableRow className={classes.tableRow}>
                                            <TableCell style={{width: '70%'}} className={classes.tableCell}>
                                                <List style={{padding: '0'}}>
                                                    <ListItem className={classes.eventListItem} disableGutters>
                                                        <ListItemIcon>
                                                            <Avatar>
                                                                {(activity.Photo !== null && activity.Photo !== "" && activity.Photo.endsWith('g')) ?
                                                                    <img src={activity.Photo} class="activity-avatar"/>
                                                                    :
                                                                    <img height={42} width={42}
                                                                         src={require(`../../../images/Alphabets/${activity.ActivityTitle.match(/[a-z]/i)[0].toUpperCase()}.png`)}/>
                                                                }
                                                            </Avatar>
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            primary={activity.ActivityTitle}
                                                            className={classes.eventListItemText}
                                                            primaryTypographyProps={{
                                                                className: classes.eventText
                                                            }}
                                                        />
                                                    </ListItem>
                                                </List>
                                            </TableCell>
                                          { size > 6 ?
                                            <TableCell className={classes.tableCell}>
                                                <div style={{fontWeight: 500, fontSize: '11px'}}>
                                                    <span style={{fontWeight: '800'}}>{moment.utc(activity.ActivityDate).local().format('MMM Do, YYYY')}</span>
                                                  {`  at  `}
                                                    <span style={{fontWeight: '800'}}>{moment.utc(activity.ActivityDate).local().format('hh:mm A')}</span>
                                                </div>
                                            </TableCell>
                                          :
                                            <TableCell className={classes.tableCell}>
                                                <div style={{fontWeight: 500, fontSize: '11px'}}><span
                                                  style={{fontWeight: '800'}}>{moment.utc(activity.ActivityDate).local().format('MMM Do, YYYY')}</span>
                                                  {`  at `}
                                                </div>
                                                <div style={{fontWeight: 500, fontSize: '11px'}}><span
                                                  style={{fontWeight: '800'}}>{moment.utc(activity.ActivityDate).local().format('hh:mm A')}</span>
                                                </div>
                                            </TableCell>
                                          }
                                        </TableRow>
                                    )
                            })}
                        </TableBody>
                        {
                            size > 6 &&
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        className={classes.page}
                                        colSpan={2}
                                        count={size}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        rowsPerPageOptions={[10, 25]}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        ActionsComponent={TablePaginationActionsWrapped}
                                    />
                                </TableRow>
                            </TableFooter>
                        }
                    </Table>
                    {
                        (!activity.activityReceived) ? <center><Loader/></center>
                            :
                            (!activity.results.BusinessActivity.length > 0) &&
                            <div className="no-data">
                                <p><i className="fa fa-exclamation-triangle" aria-hidden="true"/></p>
                                <p className="msg">You don't have any Recent Activity Yet.</p>
                            </div>
                    }
                </div>


            </div>
        )
    }
}
const mapStateToProps=(state)=> {
    return {
        activity:state.activity,
        user:state.loginResponse.results
    }
};
const matchDispatchToProps=(dispatch)=> {
    return bindActionCreators({
        fetchActivityAction
    },dispatch)
};
export default connect(mapStateToProps,matchDispatchToProps)(withStyles(styles)(ActivityTable));